import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}

  const routes = [
  // ============================== AUTH ==================================
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/menuList',
    name: 'menuList',
    component: () => import('../views/auth/menuList.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/klpUsers',
    name: 'klpUsers',
    component: () => import('../views/auth/klpUsers.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/auth/register.vue'),
    beforeEnter: isLoggedIn,
  },
  // ============================== AUTH ==================================

  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },

  {
    path: '/profilku',
    name: 'profilku',
    component: () => import('../views/myprofile/profilku.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/usulanLokasiAbsen',
    name: 'usulanLokasiAbsen',
    component: () => import('../views/verifikasiLokasiAbsen/usulanLokasiAbsen.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/masterLevel',
    name: 'masterLevel',
    component: () => import('../views/dataMaster/masterLevel.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/biodataPegawai',
    name: 'biodataPegawaiout',
    component: () => import('../views/profilPegawai/biodataPegawai.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/kartuPegawai',
    name: 'kartuPegawai',
    component: () => import('../views/profilPegawai/kartuPegawai.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/skpPegawai',
    name: 'skpPegawai',
    component: () => import('../views/profilPegawai/skpPegawai.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/dataSuamiIstri',
    name: 'dataSuamiIstri',
    component: () => import('../views/profilPegawai/dataKeluarga/dataSuamiIstri'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/dataAnak',
    name: 'dataAnak',
    component: () => import('../views/profilPegawai/dataKeluarga/dataAnak'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/skPengangkatan',
    name: 'skPengangkatan',
    component: () => import('../views/profilPegawai/riwayatKepangkatan/skPengangkatan'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/kepangkatan',
    name: 'kepangkatan',
    component: () => import('../views/profilPegawai/riwayatKepangkatan/kepangkatan'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/jabatanStruktural',
    name: 'jabatanStruktural',
    component: () => import('../views/profilPegawai/riwayatKepangkatan/jabatanStruktural'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/jabatanFungsional',
    name: 'jabatanFungsional',
    component: () => import('../views/profilPegawai/riwayatKepangkatan/jabatanFungsional'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/pendidikanFormal',
    name: 'pendidikanFormal',
    component: () => import('../views/riwayatPendidikan/pendidikanFormal'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/diklatFungsional',
    name: 'diklatFungsional',
    component: () => import('../views/riwayatPendidikan/diklatFungsional'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/diklatStruktural',
    name: 'diklatStruktural',
    component: () => import('../views/riwayatPendidikan/diklatStruktural'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/riwayatKursus',
    name: 'riwayatKursus',
    component: () => import('../views/riwayatPendidikan/riwayatKursus'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/riwayatHukdis',
    name: 'riwayatHukdis',
    component: () => import('../views/profilPegawai/riwayatHukdis'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/riwayatPenghargaan',
    name: 'riwayatPenghargaan',
    component: () => import('../views/profilPegawai/riwayatPenghargaan'),
    beforeEnter: isLoggedIn,
  },

  // ============================== MONITORING ==================================
  {
    path: '/Mon_daftarUrut',
    name: 'Mon_daftarUrut',
    component: () => import('../views/monitoring/daftarUrut.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/Mon_pejabat',
    name: 'Mon_pejabat',
    component: () => import('../views/monitoring/pejabat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/Mon_strukturOrganisasi',
    name: 'Mon_strukturOrganisasi',
    component: () => import('../views/monitoring/strukturOrganisasi.vue'),
    beforeEnter: isLoggedIn,
  },


  // ============================== MONITORING ==================================



  // ============================== DATA MASTER ==================================

  {
    path: '/masterJenisJabatan',
    name: 'masterJenisJabatan',
    component: () => import('../views/dataMaster/MasterJabatan/masterJenisJabatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterKelasJabatan',
    name: 'masterKelasJabatan',
    component: () => import('../views/dataMaster/MasterJabatan/masterKelasJabatan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterJabatan',
    name: 'masterJabatan',
    component: () => import('../views/dataMaster/MasterJabatan/masterJabatan.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/masterPangkatGolongan',
    name: 'masterPangkatGolongan',
    component: () => import('../views/dataMaster/masterPangkatGolongan'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/MasterJenisKel',
    name: 'MasterJenisKel',
    component: () => import('../views/dataMaster/MasterJenisKel'),
    beforeEnter: isLoggedIn,
  },
  
  {
    path: '/masterAgama',
    name: 'masterAgama',
    component: () => import('../views/dataMaster/masterAgama'),
    beforeEnter: isLoggedIn,
  },
  
  {
    path: '/masterPendidikanAkhir',
    name: 'masterPendidikanAkhir',
    component: () => import('../views/dataMaster/masterPendidikanAkhir'),
    beforeEnter: isLoggedIn,
  },
  
  {
    path: '/masterStatusKel',
    name: 'masterStatusKel',
    component: () => import('../views/dataMaster/masterStatusKel'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/MasterProvinsi',
    name: 'MasterProvinsi',
    component: () => import('../views/dataMaster/MasterWilayah/MasterProvinsi'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/MasterKabupaten',
    name: 'MasterKabupaten',
    component: () => import('../views/dataMaster/MasterWilayah/MasterKabupaten'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/MasterKecamatan',
    name: 'MasterKecamatan',
    component: () => import('../views/dataMaster/MasterWilayah/MasterKecamatan'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/MasterDesKel',
    name: 'MasterDesKel',
    component: () => import('../views/dataMaster/MasterWilayah/MasterDesKel'),
    beforeEnter: isLoggedIn,
  },

  // ============================== DATA MASTER ==================================

  {
    path: '/angkaKredit',
    name: 'angkaKredit',
    component: () => import('../views/angkaKredit/angkaKredit'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/cpns',
    name: 'cpns',
    component: () => import('../views/profilPegawai/riwayatKepangkatan/cpns'),
    beforeEnter: isLoggedIn,
  },

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
